import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Typography, Stack, Button, IconButton } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Iconify from '../../../components/iconify';

// api
import { getGenericData, deleteGenericData, updateGenericData } from '../../api';
import PopoverFiltroBasico from '../../PopoverFiltroBasico';
import ModalLoading from '../../ModalLoading';
import ModalConfirmacao from '../../ModalConfirmacao';
import { cores } from '../../../styles/styleUtils';

import NewSaidaForm from '../NewSaida/NewSaidaForm';

// ----------------------------------------------------------------------

export default function Saidas() {
  const [propostas, setPropostas] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [isNewSaleModalOpen, setIsNewSaleModalOpen] = useState(false);
  const [produto, setProduto] = React.useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);

  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuarioLogado,
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
    tipo: 'saida'
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro]);

  const fGetPropostas = async (filtro) => {
    try {
      const result = await getGenericData('movimentacaoestoque', filtro);
      setPropostas(result);
    } catch (error) {
      window.alert('Erro ao consultar banco de dados');
      console.error('Erro ao buscar dados da API:', error);
    }
  };

  const confirmDelete = async () => {
    setModalLoading(true);
    await deleteGenericData('movimentacaoestoque', produto);
    closeModalConfirmacaDelete();
    fGetPropostas(filtro);
    setProduto(null);
    setModalLoading(false);
  };

  const onConfirmNewSale = async (data) => {
    await updateGenericData('movimentacaoestoque', data);
    fGetPropostas(filtro);
    handleCloseNewSaleModal();
  };

  const handleOpenNewSaleModal = () => {
    setIsNewSaleModalOpen(true);
  };

  const handleCloseNewSaleModal = () => {
    setIsNewSaleModalOpen(false);
    setProduto(null);
  };

  const handleDoubleClickTable = async (row) => {
    setProduto({ ...row, visualiza: true });
    setIsNewSaleModalOpen(true);
  };

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  const handleDeleteClick = (row) => {
    setProduto({ ...row });
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setModalConfirmacaoDelete(false);
    setProduto(null);
  };
  // ----------------------


  return (
    <>
      <Helmet>
        <title> Saídas </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Saídas
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: cores.laranja,
              marginLeft: 'auto',
              '&:hover': { backgroundColor: cores.laranjaEscuro },
            }}
          >
            Filtros
          </Button>

          <Button
            variant="contained"
            onClick={handleOpenNewSaleModal}
            startIcon={<Iconify icon="zondicons:add-solid" />}
            sx={{ height: 50, minWidth: 100, marginLeft: 1 }}
          >
            Adicionar
          </Button>
        </Stack>

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Data</TableCell>
                <TableCell align="left">Fornecedor</TableCell>
                <TableCell align="center">Unidade</TableCell>
                <TableCell align="center" />
                {usuarioLogado.supervisor && <TableCell align="center"> </TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {propostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:hover': { backgroundColor: cores.cinzaClaro },
                    ...(row.finalizado?.nome === 'Rejeitado' && {
                      color: 'red',
                      textDecoration: 'line-through',
                    }),
                  }}
                  onDoubleClick={() => handleDoubleClickTable(row)}
                >
                  <TableCell align="center">
                    {new Date(row.data).toLocaleDateString('pt-BR', {
                      timeZone: 'UTC',
                    })}
                  </TableCell>
                  <TableCell align="left">{row.fornecedor?.nome}</TableCell>
                  <TableCell align="center">{row.unidade?.nome}</TableCell>


                  <TableCell align="center">
                    {row.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </TableCell>
                  {/* Ícone de exclusão visível apenas para supervisores */}
                  {usuarioLogado.supervisor && (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDeleteClick(row)}>
                        <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left" colSpan={4}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center">
                  Quantidade: <strong>{propostas.length}</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>
                    {propostas
                      .reduce((acc, curr) => acc + (curr.valor || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {openFiltro ? (
        <PopoverFiltroBasico
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
        />
      ) : null}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}

      {modalConfirmacaoDelete ? (
        <ModalConfirmacao
          title={'Tem certeza que deseja excluir esse produto?'}
          subtitle={`${produto.descricao} - ${produto.fornecedor?.nome}`}
          open={modalConfirmacaoDelete}
          onClose={closeModalConfirmacaDelete}
          onConfirm={confirmDelete}
        />
      ) : null}

      {isNewSaleModalOpen && (
        <NewSaidaForm
          open={isNewSaleModalOpen}
          formData={produto}
          handleClose={handleCloseNewSaleModal}
          onConfirm={onConfirmNewSale}
        />
      )}
    </>
  );
}